'use strict';

/// /////////////////////////////////////////////////////////////////////////////////////////////////////
//                                Example of usage                                                    //
//                         i18n(text, [arg1, arg2, argN]);                                            //
//                                                                                                    //
//  E1.                                                                                               //
//  i18n(                                                                                             //
//        'Do you really want to delete user {3} {4} from this address {0}, {1}, {2}?',               //
//        [                                                                                           //
//            'Hans Roth Strasse 1'                                                                   //
//            '8073',                                                                                 //
//            'Feldkirchen bei Graz',                                                                 //
//            'John',                                                                                 //
//            'Wayne'                                                                                 //
//  ]);                                                                                               //
//  Output => Möchten Sie den Benutzer John Wayne von der                                             //
//            Adresse Hans Roth Strasse 1, 8073, Feldkirchen bei Graz wirklich entfernen?             //
//                                                                                                    //
//  E2.                                                                                               //
//  i18n('Container size')                                                                            //
//  Output => Behältergröße                                                                           //
/// /////////////////////////////////////////////////////////////////////////////////////////////////////

window.i18n = (source, parameters) => {
  let key = window.initLocale && window.initLocale.translations ? window.initLocale.translations[source] : undefined;
  if (key === undefined) {
    const parametersString = parameters ? ` params: ${parameters}` : '';
    console.error(`translation for "${source}" not found!${parametersString}`);
    return `<error>Missing translation: ${source}</error>`;
  }

  if (parameters === undefined) {
    return key;
  }

  if (Array.isArray(parameters)) {
    parameters.forEach((n, i) => {
      key = key.replaceAll(new RegExp(`\\{${i}\\}`, 'g'), n);
    });

    return key;
  }

  return `<error>Wrong Params at translation: ${source}</error>`;
};
